import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { ProgressSpinner } from "@emisgroup/ui-progress-indicator";
import { NoDetails } from "../../../../Common/NoDetails/NoDetails";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { resetCode } from "../../redux/Slice";
import { AsyncBoundary } from "../../../../../common/AsyncBoundry/AsyncBoundry";
import { ICodeListItem } from "../interfaces";
import { NoCodesIcon } from "./NoCodesIcon";
import { CodeList } from "./CodeList";
import { WarningIcon } from "./WarningIcon";
import Close from "~icons/ic/baseline-close";
import "./Style.scss";

export const CodeDetails: React.FC<{ isOlderThanFiveDays: boolean }> = ({ isOlderThanFiveDays }) => {
  const { t: translate } = useTranslation();
  const codeListViewData = useSelector((state: IRootState) => state.codeListView);
  const [showWarning, setShowWarning] = useState(false);
  const dispatch = useDispatch();

  if(!codeListViewData.codeListView.codeListId) {
    return (
      <NoDetails
        style={{ paddingTop: "20vh" }}
        title={translate("ResultDetails.CodeList.NoRulesOrCodes")}
        description={translate("ResultDetails.CodeList.Description")}
        notFoundIcon={<NoCodesIcon/>}
      />
    );
  }

  const title =
    translate("ResultDetails.CodeList.CodesForA")
      .replace("{codeName}", codeListViewData.codeListView.codeListName)
    ;

  const handleWarning = (data: ICodeListItem[], hasErrors: boolean): void => {
    const shouldShowWarning = !hasErrors && !!data.filter(item => item.countIncluded === 0).length;
    setShowWarning(shouldShowWarning);
  };

  return (
    <div className="rules-details-container">
      <div className="rules-details-header">
        <h3>{title}</h3>
        <div
          data-testId="closeIconId"
          style={{ cursor: "pointer" }}
          onClick={(): void => { dispatch(resetCode()); } }>
          <Close title={translate("ResultDetails.CodeList.Close")} />
        </div>
      </div>
      <AsyncBoundary
        key={codeListViewData.codeListView.codeListId}
        suspenseFallback= {
          <div style={{ position: "relative", padding: "25vh" }}>
            <ProgressSpinner delay={100} text={translate("ResultDetails.CodeList.FetchingCodeList")} />
          </div>
        }
      >
        <CodeList
          isExportDisabled={isOlderThanFiveDays}
          selectedCode={codeListViewData.codeListView}
          onDataReady= { handleWarning }/>
        {
          showWarning &&
          <div className="rules-details-warning">
            <WarningIcon/>
            <p className="rules-details-info">
              { translate("ResultDetails.CodeList.ZeroResults") }
            </p>
          </div>
        }
      </AsyncBoundary>
    </div>
  );
};
